<template>
  <div class="announceIndex">
    <h2 class="sr-only">網站消息</h2>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "announceIndex"
};
</script>
<style lang="scss" scoped>
.announceIndex {
  height: inherit;
}
</style>
